import React from 'react'

export const FacebookIcon = () => {
  return (

    <svg
      width="14"
      height="21"
      viewBox="0 0 14 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="facebook-icon facebook-icon-wrapper"
    >
      <path
        className="facebook-path"
        d="M3.6375 11.7227V20.0312H8.7125V11.7227H12.4969L13.2844 7.90234H8.7125V6.55078C8.7125 4.53125 9.60063 3.75781 11.8931 3.75781C12.6063 3.75781 13.1794 3.77344 13.5119 3.80469V0.339844C12.8863 0.1875 11.355 0.03125 10.4712 0.03125C5.79437 0.03125 3.6375 2.00391 3.6375 6.25781V7.90234H0.75V11.7227H3.6375Z"
        fill="#323232"
      />
    </svg>
  )
}
